import { HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';

export class OpenapiHttpContext extends HttpContext {
  public headersOverride?: (headers: HttpHeaders) => HttpHeaders;

  public processRequestHeaders(headers: HttpHeaders): HttpHeaders {
    if (typeof this.headersOverride === 'function') {
      return this.headersOverride(headers);
    }
    return headers;
  }

  public processResponse(response: HttpResponse<unknown>): void {

  }
}
